import { render, staticRenderFns } from "./statsFormView.vue?vue&type=template&id=164aeef6&scoped=true&"
import script from "./statsFormView.vue?vue&type=script&lang=js&"
export * from "./statsFormView.vue?vue&type=script&lang=js&"
import style0 from "./statsFormView.vue?vue&type=style&index=0&id=164aeef6&scoped=true&lang=scss&"
import style1 from "./statsFormView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164aeef6",
  null
  
)

export default component.exports